import { Button, Div, Text, RefBool, Span, CollectionPrinter } from "@tblabs/truffle";
import { Center } from "../Utils/Center";
import { Heading } from "../Heading";
import { CloseBasketButton } from "./CloseBasketButton";
import { DiscountBox } from "../../Pages/Product/Components/DiscountBox";
import { MiniBasketItem } from "./MiniBasketItem";
import { BasketProvider } from "../../Services/BasketProvider";


export class MiniBasketBox extends Div
{
    constructor(private _basket: BasketProvider, private showMiniBasket: RefBool)
    {
        super("MiniBasketBox");

        this.Visible(showMiniBasket);
    }

    async OnAppend(): Promise<void>
    {
        const basket = this._basket.Basket;

        this.Append(
            new Div("cart-summary__overlay cart-summary__overlay--fade-in")
                .OnClick(() => this.showMiniBasket.False()),
            new Div("cart-summary cart-summary--drawer")
                .Attribute("role", "dialog").Attribute("aria-modal", "true").Style("opacity: 1; transform: none;")
                .Append(
                    new CloseBasketButton(this.showMiniBasket),
                    new Heading("Twój koszyk", 2, "cart-summary__title"),
                    new Div("cart-summary__content").Append(
                        new Div("cart-summary__sections").Append(
                            // TODO: tu był podział na kategorie ale jest problem przy usuwaniu i odświeżaniu listy. fajnie by było jakby CollectionView miało jakiś filtr (metoda Take(predicate) lub coś taiego)
                            // new MiniBasketSection("Wypożyczenie", _basket.GetItemsByType(BasketItemType.Rent)),
                            // new MiniBasketSection("Zakup", _basket.GetItemsByType(BasketItemType.Sale)),
                            // TODO: więc póki co będzie tak: bez bajerów, tylko wszystkie produkty w jednej liście
                            new CollectionPrinter(basket.Items, item => new MiniBasketItem(item, basket))
                                .VisibleWhen(basket.Items.CountRef, v => v > 0),
                            new Center("Jest pusty").MarginTop(32)
                                .VisibleWhen(basket.Items.CountRef, v => v == 0)
                        ),
                    ),
                    new DiscountBox(basket, basket.TotalPriceBeforeDiscounts),
                    new Div("cart-summary__actions").Append(
                        new Div("cart-summary__total").Append(
                            new Span("Suma:").Class("text-label-lg"),
                            new Text(basket.TotalPriceAfterDiscounts, v => v + " zł").Class("text-value-xl-bold")
                        ),
                        new Button("Przejdź do kasy").Class("btn-action-primary")
                            .EnableWhen(basket.Items.CountRef, v => +v > 0)
                            .OnClick(() =>
                            {
                                this.showMiniBasket.False();
                                window.location.hash = "koszyk";
                            }),
                    )
                )
        )
    }
}
